import { DropdownOption } from './DropdownOption'

export type InternalDropdownsKey = 'weekDays' | 'orderStatuses' | 'breakStatuses' | 'notificationTypes' | 'recipientTypes' | 'notificationOrderEventTypes' | 'vehicleTypes' | 'safetyCheckTypes' | 'htmlColors' | 'timeZones'
export const internalDropdowns: Record<InternalDropdownsKey, DropdownOption[]> = {
  weekDays: [
    { label: 'Sunday', value: 0 },
    { label: 'Monday', value: 1 },
    { label: 'Tuesday', value: 2 },
    { label: 'Wednesday', value: 3 },
    { label: 'Thursday', value: 4 },
    { label: 'Friday', value: 5 },
    { label: 'Saturday', value: 6 },
  ],

  orderStatuses: [
    { value: 0, label: 'Planning', fontColor: 'black', backgroundColor: '' },
    { value: 100, label: 'Unassigned', fontColor: 'black', backgroundColor: '' },
    { value: 105, label: 'Rescheduled', fontColor: 'white', backgroundColor: 'blue' },
    { value: 110, label: 'Allocated', fontColor: 'white', backgroundColor: 'gray' },
    { value: 120, label: 'Received In Field', fontColor: 'black', backgroundColor: 'orange' },
    { value: 130, label: 'Loaded', fontColor: 'black', backgroundColor: 'yellow' },
    { value: 140, label: 'Arrived', fontColor: 'white', backgroundColor: 'teal' },
    { value: 150, label: 'Started', fontColor: 'black', backgroundColor: 'palegreen' },
    { value: 155, label: 'Partial', fontColor: 'white', backgroundColor: 'teal' },
    { value: 160, label: 'Completed', fontColor: 'white', backgroundColor: 'green' },
    { value: 165, label: 'Completed By Sup', fontColor: 'black', backgroundColor: 'limegreen' },
    { value: 200, label: 'Cancelled', fontColor: 'white', backgroundColor: 'black' },
    { value: 300, label: 'Load Exception', fontColor: 'white', backgroundColor: 'red' },
    { value: 310, label: 'Exception', fontColor: 'white', backgroundColor: 'red' },
  ],

  breakStatuses: [
    { label: 'Break Not Started', value: 400 },
    { label: 'Break Completed', value: 405 },
    { label: 'Driver On Break', value: 410 },
  ],

  notificationTypes: [
    { value: 1, label: 'Email' },
    { value: 2, label: 'SMS' },
    { value: 3, label: 'Notification' },
  ],
  recipientTypes: [
    { value: 1, label: 'Customer' },
    { value: 2, label: 'PortalClient' },
    { value: 3, label: 'Customer Service' },
    { value: 4, label: 'Driver' },
    { value: 5, label: 'DriverManager' },
    { value: 6, label: 'Pickup' },
    { value: 7, label: 'Delivery' },
  ],
  notificationOrderEventTypes: [
    { label: 'Scheduled', value: 100 },
    { label: 'Loaded', value: 130 },
    { label: 'Completed', value: 160 },
    { label: 'Delivery Exception', value: 310 },
    { label: 'Revised ETA', value: 500 },
    { label: 'Revised ETA Pickup', value: 501 },
    { label: 'Revised ETA Delivery', value: 502 },
    { label: 'Revised ETA Outside Time Window', value: 510 },
    { label: 'Revised ETA Pickup Outside Time Window', value: 511 },
    { label: 'Revised ETA Delivery Outside Time Window', value: 512 },
    { label: 'Revised ETA Violation', value: 520 },
    { label: 'Revised ETA Pickup Violation', value: 521 },
    { label: 'Revised ETA Delivery Violation', value: 522 },
    { label: 'Run Completed', value: 550 },
    { label: 'Fatigue Breach', value: 560 },
    { label: 'Demurrage Arrived', value: 600 },
    { label: 'Demurrage', value: 610 },
    { label: 'DemurrageWaitTime', value: 620 },
    { label: 'Next Job', value: 630 },
    { label: 'Tracking Link', value: 640 },
  ],

  vehicleTypes: [
    { label: 'Car', value: 10 },
    { label: 'Van', value: 20 },
    { label: 'Truck', value: 30 },
    { label: 'Trailer', value: 40 },
    { label: 'Tractor', value: 50 },
  ],

  safetyCheckTypes: [
    { label: 'Shift Start', value: 10 },
    { label: 'Shift End', value: 20 },
    { label: 'Load Start', value: 30 },
  ],

  htmlColors: [
    { label: 'Aqua', value: 'Aqua' },
    { label: 'Black', value: 'Black' },
    { label: 'Blue', value: 'Blue' },
    { label: 'BlueViolet', value: 'BlueViolet' },
    { label: 'Brown', value: 'Brown' },
    { label: 'Coral', value: 'Coral' },
    { label: 'CornflowerBlue', value: 'CornflowerBlue' },
    { label: 'Crimson', value: 'Crimson' },
    { label: 'DarkBlue', value: 'DarkBlue' },
    { label: 'DarkCyan', value: 'DarkCyan' },
    { label: 'DarkGray', value: 'DarkGray' },
    { label: 'DarkGreen', value: 'DarkGreen' },
    { label: 'DarkRed', value: 'DarkRed' },
    { label: 'DarkSalmon', value: 'DarkSalmon' },
    { label: 'DeepPink', value: 'DeepPink' },
    { label: 'FireBrick', value: 'FireBrick' },
    { label: 'Gold', value: 'Gold' },
    { label: 'Goldenrod', value: 'Goldenrod' },
    { label: 'Gray', value: 'Gray' },
    { label: 'Green', value: 'Green' },
    { label: 'HotPink', value: 'HotPink' },
    { label: 'IndianRed', value: 'IndianRed' },
    { label: 'Lavender', value: 'Lavender' },
    { label: 'LightBlue', value: 'LightBlue' },
    { label: 'LightSeaGreen', value: 'LightSeaGreen' },
    { label: 'LightCoral', value: 'LightCoral' },
    { label: 'LimeGreen', value: 'LimeGreen' },
    { label: 'MediumOrchid', value: 'MediumOrchid' },
    { label: 'MediumVioletRed', value: 'MediumVioletRed' },
    { label: 'Olive', value: 'Olive' },
    { label: 'Orange', value: 'Orange' },
    { label: 'OrangeRed', value: 'OrangeRed' },
    { label: 'Orchid', value: 'Orchid' },
    { label: 'PaleVioletRed', value: 'PaleVioletRed' },
    { label: 'Pink', value: 'Pink' },
    { label: 'Purple', value: 'Purple' },
    { label: 'Red', value: 'Red' },
    { label: 'RoyalBlue', value: 'RoyalBlue' },
    { label: 'Salmon', value: 'Salmon' },
    { label: 'SteelBlue', value: 'SteelBlue' },
    { label: 'Teal', value: 'Teal' },
    { label: 'Tomato', value: 'Tomato' },
    { label: 'Violet', value: 'Violet' },
    { label: 'Yellow', value: 'Yellow' },
  ],

  timeZones: [
    {
      value: 'Dateline Standard Time',
      label: '(UTC-12:00) International Date Line West',
      offset: '-12:00',
    },
    {
      value: 'UTC-11',
      label: '(UTC-11:00) Coordinated Universal Time-11',
      offset: '-11:00',
    },
    {
      value: 'Aleutian Standard Time',
      label: '(UTC-10:00) Aleutian Islands',
      offset: '-10:00',
    },
    {
      value: 'Hawaiian Standard Time',
      label: '(UTC-10:00) Hawaii',
      offset: '-10:00',
    },
    {
      value: 'Marquesas Standard Time',
      label: '(UTC-09:30) Marquesas Islands',
      offset: '-09:30',
    },
    {
      value: 'Alaskan Standard Time',
      label: '(UTC-09:00) Alaska',
      offset: '-09:00',
    },
    {
      value: 'UTC-09',
      label: '(UTC-09:00) Coordinated Universal Time-09',
      offset: '-09:00',
    },
    {
      value: 'Pacific Standard Time (Mexico)',
      label: '(UTC-08:00) Baja California',
      offset: '-08:00',
    },
    {
      value: 'UTC-08',
      label: '(UTC-08:00) Coordinated Universal Time-08',
      offset: '-08:00',
    },
    {
      value: 'Pacific Standard Time',
      label: '(UTC-08:00) Pacific Time (US & Canada)',
      offset: '-08:00',
    },
    {
      value: 'US Mountain Standard Time',
      label: '(UTC-07:00) Arizona',
      offset: '-07:00',
    },
    {
      value: 'Mountain Standard Time (Mexico)',
      label: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
      offset: '-07:00',
    },
    {
      value: 'Mountain Standard Time',
      label: '(UTC-07:00) Mountain Time (US & Canada)',
      offset: '-07:00',
    },
    {
      value: 'Central America Standard Time',
      label: '(UTC-06:00) Central America',
      offset: '-06:00',
    },
    {
      value: 'Central Standard Time',
      label: '(UTC-06:00) Central Time (US & Canada)',
      offset: '-06:00',
    },
    {
      value: 'Easter Island Standard Time',
      label: '(UTC-06:00) Easter Island',
      offset: '-06:00',
    },
    {
      value: 'Central Standard Time (Mexico)',
      label: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
      offset: '-06:00',
    },
    {
      value: 'Canada Central Standard Time',
      label: '(UTC-06:00) Saskatchewan',
      offset: '-06:00',
    },
    {
      value: 'SA Pacific Standard Time',
      label: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
      offset: '-05:00',
    },
    {
      value: 'Eastern Standard Time (Mexico)',
      label: '(UTC-05:00) Chetumal',
      offset: '-05:00',
    },
    {
      value: 'Eastern Standard Time',
      label: '(UTC-05:00) Eastern Time (US & Canada)',
      offset: '-05:00',
    },
    {
      value: 'Haiti Standard Time',
      label: '(UTC-05:00) Haiti',
      offset: '-05:00',
    },
    {
      value: 'Cuba Standard Time',
      label: '(UTC-05:00) Havana',
      offset: '-05:00',
    },
    {
      value: 'US Eastern Standard Time',
      label: '(UTC-05:00) Indiana (East)',
      offset: '-05:00',
    },
    {
      value: 'Paraguay Standard Time',
      label: '(UTC-04:00) Asuncion',
      offset: '-04:00',
    },
    {
      value: 'Atlantic Standard Time',
      label: '(UTC-04:00) Atlantic Time (Canada)',
      offset: '-04:00',
    },
    {
      value: 'Venezuela Standard Time',
      label: '(UTC-04:00) Caracas',
      offset: '-04:00',
    },
    {
      value: 'Central Brazilian Standard Time',
      label: '(UTC-04:00) Cuiaba',
      offset: '-04:00',
    },
    {
      value: 'SA Western Standard Time',
      label: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
      offset: '-04:00',
    },
    {
      value: 'Pacific SA Standard Time',
      label: '(UTC-04:00) Santiago',
      offset: '-04:00',
    },
    {
      value: 'Turks And Caicos Standard Time',
      label: '(UTC-04:00) Turks and Caicos',
      offset: '-04:00',
    },
    {
      value: 'Newfoundland Standard Time',
      label: '(UTC-03:30) Newfoundland',
      offset: '-03:30',
    },
    {
      value: 'Tocantins Standard Time',
      label: '(UTC-03:00) Araguaina',
      offset: '-03:00',
    },
    {
      value: 'E. South America Standard Time',
      label: '(UTC-03:00) Brasilia',
      offset: '-03:00',
    },
    {
      value: 'SA Eastern Standard Time',
      label: '(UTC-03:00) Cayenne, Fortaleza',
      offset: '-03:00',
    },
    {
      value: 'Argentina Standard Time',
      label: '(UTC-03:00) City of Buenos Aires',
      offset: '-03:00',
    },
    {
      value: 'Greenland Standard Time',
      label: '(UTC-03:00) Greenland',
      offset: '-03:00',
    },
    {
      value: 'Montevideo Standard Time',
      label: '(UTC-03:00) Montevideo',
      offset: '-03:00',
    },
    {
      value: 'Saint Pierre Standard Time',
      label: '(UTC-03:00) Saint Pierre and Miquelon',
      offset: '-03:00',
    },
    {
      value: 'Bahia Standard Time',
      label: '(UTC-03:00) Salvador',
      offset: '-03:00',
    },
    {
      value: 'UTC-02',
      label: '(UTC-02:00) Coordinated Universal Time-02',
      offset: '-02:00',
    },
    {
      value: 'Mid-Atlantic Standard Time',
      label: '(UTC-02:00) Mid-Atlantic - Old',
      offset: '-02:00',
    },
    {
      value: 'Azores Standard Time',
      label: '(UTC-01:00) Azores',
      offset: '-01:00',
    },
    {
      value: 'Cape Verde Standard Time',
      label: '(UTC-01:00) Cabo Verde Is.',
      offset: '-01:00',
    },
    {
      value: 'UTC',
      label: '(UTC) Coordinated Universal Time',
      offset: '+00:00',
    },
    {
      value: 'Morocco Standard Time',
      label: '(UTC+00:00) Casablanca',
      offset: '+00:00',
    },
    {
      value: 'GMT Standard Time',
      label: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
      offset: '+00:00',
    },
    {
      value: 'Greenwich Standard Time',
      label: '(UTC+00:00) Monrovia, Reykjavik',
      offset: '+00:00',
    },
    {
      value: 'W. Europe Standard Time',
      label: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
      offset: '+01:00',
    },
    {
      value: 'Central Europe Standard Time',
      label: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
      offset: '+01:00',
    },
    {
      value: 'Romance Standard Time',
      label: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
      offset: '+01:00',
    },
    {
      value: 'Central European Standard Time',
      label: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
      offset: '+01:00',
    },
    {
      value: 'W. Central Africa Standard Time',
      label: '(UTC+01:00) West Central Africa',
      offset: '+01:00',
    },
    {
      value: 'Namibia Standard Time',
      label: '(UTC+01:00) Windhoek',
      offset: '+01:00',
    },
    {
      value: 'Jordan Standard Time',
      label: '(UTC+02:00) Amman',
      offset: '+02:00',
    },
    {
      value: 'GTB Standard Time',
      label: '(UTC+02:00) Athens, Bucharest',
      offset: '+02:00',
    },
    {
      value: 'Middle East Standard Time',
      label: '(UTC+02:00) Beirut',
      offset: '+02:00',
    },
    {
      value: 'Egypt Standard Time',
      label: '(UTC+02:00) Cairo',
      offset: '+02:00',
    },
    {
      value: 'E. Europe Standard Time',
      label: '(UTC+02:00) Chisinau',
      offset: '+02:00',
    },
    {
      value: 'Syria Standard Time',
      label: '(UTC+02:00) Damascus',
      offset: '+02:00',
    },
    {
      value: 'West Bank Standard Time',
      label: '(UTC+02:00) Gaza, Hebron',
      offset: '+02:00',
    },
    {
      value: 'South Africa Standard Time',
      label: '(UTC+02:00) Harare, Pretoria',
      offset: '+02:00',
    },
    {
      value: 'FLE Standard Time',
      label: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
      offset: '+02:00',
    },
    {
      value: 'Israel Standard Time',
      label: '(UTC+02:00) Jerusalem',
      offset: '+02:00',
    },
    {
      value: 'Kaliningrad Standard Time',
      label: '(UTC+02:00) Kaliningrad',
      offset: '+02:00',
    },
    {
      value: 'Libya Standard Time',
      label: '(UTC+02:00) Tripoli',
      offset: '+02:00',
    },
    {
      value: 'Arabic Standard Time',
      label: '(UTC+03:00) Baghdad',
      offset: '+03:00',
    },
    {
      value: 'Turkey Standard Time',
      label: '(UTC+03:00) Istanbul',
      offset: '+03:00',
    },
    {
      value: 'Arab Standard Time',
      label: '(UTC+03:00) Kuwait, Riyadh',
      offset: '+03:00',
    },
    {
      value: 'Belarus Standard Time',
      label: '(UTC+03:00) Minsk',
      offset: '+03:00',
    },
    {
      value: 'Russian Standard Time',
      label: '(UTC+03:00) Moscow, St. Petersburg, Volgograd',
      offset: '+03:00',
    },
    {
      value: 'E. Africa Standard Time',
      label: '(UTC+03:00) Nairobi',
      offset: '+03:00',
    },
    {
      value: 'Iran Standard Time',
      label: '(UTC+03:30) Tehran',
      offset: '+03:30',
    },
    {
      value: 'Arabian Standard Time',
      label: '(UTC+04:00) Abu Dhabi, Muscat',
      offset: '+04:00',
    },
    {
      value: 'Astrakhan Standard Time',
      label: '(UTC+04:00) Astrakhan, Ulyanovsk',
      offset: '+04:00',
    },
    {
      value: 'Azerbaijan Standard Time',
      label: '(UTC+04:00) Baku',
      offset: '+04:00',
    },
    {
      value: 'Russia Time Zone 3',
      label: '(UTC+04:00) Izhevsk, Samara',
      offset: '+04:00',
    },
    {
      value: 'Mauritius Standard Time',
      label: '(UTC+04:00) Port Louis',
      offset: '+04:00',
    },
    {
      value: 'Georgian Standard Time',
      label: '(UTC+04:00) Tbilisi',
      offset: '+04:00',
    },
    {
      value: 'Caucasus Standard Time',
      label: '(UTC+04:00) Yerevan',
      offset: '+04:00',
    },
    {
      value: 'Afghanistan Standard Time',
      label: '(UTC+04:30) Kabul',
      offset: '+04:30',
    },
    {
      value: 'West Asia Standard Time',
      label: '(UTC+05:00) Ashgabat, Tashkent',
      offset: '+05:00',
    },
    {
      value: 'Ekaterinburg Standard Time',
      label: '(UTC+05:00) Ekaterinburg',
      offset: '+05:00',
    },
    {
      value: 'Pakistan Standard Time',
      label: '(UTC+05:00) Islamabad, Karachi',
      offset: '+05:00',
    },
    {
      value: 'India Standard Time',
      label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
      offset: '+05:30',
    },
    {
      value: 'Sri Lanka Standard Time',
      label: '(UTC+05:30) Sri Jayawardenepura',
      offset: '+05:30',
    },
    {
      value: 'Nepal Standard Time',
      label: '(UTC+05:45) Kathmandu',
      offset: '+05:45',
    },
    {
      value: 'Central Asia Standard Time',
      label: '(UTC+06:00) Astana',
      offset: '+06:00',
    },
    {
      value: 'Bangladesh Standard Time',
      label: '(UTC+06:00) Dhaka',
      offset: '+06:00',
    },
    {
      value: 'Omsk Standard Time',
      label: '(UTC+06:00) Omsk',
      offset: '+06:00',
    },
    {
      value: 'Myanmar Standard Time',
      label: '(UTC+06:30) Yangon (Rangoon)',
      offset: '+06:30',
    },
    {
      value: 'SE Asia Standard Time',
      label: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
      offset: '+07:00',
    },
    {
      value: 'Altai Standard Time',
      label: '(UTC+07:00) Barnaul, Gorno-Altaysk',
      offset: '+07:00',
    },
    {
      value: 'W. Mongolia Standard Time',
      label: '(UTC+07:00) Hovd',
      offset: '+07:00',
    },
    {
      value: 'North Asia Standard Time',
      label: '(UTC+07:00) Krasnoyarsk',
      offset: '+07:00',
    },
    {
      value: 'N. Central Asia Standard Time',
      label: '(UTC+07:00) Novosibirsk',
      offset: '+07:00',
    },
    {
      value: 'Tomsk Standard Time',
      label: '(UTC+07:00) Tomsk',
      offset: '+07:00',
    },
    {
      value: 'China Standard Time',
      label: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
      offset: '+08:00',
    },
    {
      value: 'North Asia East Standard Time',
      label: '(UTC+08:00) Irkutsk',
      offset: '+08:00',
    },
    {
      value: 'Singapore Standard Time',
      label: '(UTC+08:00) Kuala Lumpur, Singapore',
      offset: '+08:00',
    },
    {
      value: 'W. Australia Standard Time',
      label: '(UTC+08:00) Perth',
      offset: '+08:00',
    },
    {
      value: 'Taipei Standard Time',
      label: '(UTC+08:00) Taipei',
      offset: '+08:00',
    },
    {
      value: 'Ulaanbaatar Standard Time',
      label: '(UTC+08:00) Ulaanbaatar',
      offset: '+08:00',
    },
    {
      value: 'North Korea Standard Time',
      label: '(UTC+08:30) Pyongyang',
      offset: '+08:30',
    },
    {
      value: 'Aus Central W. Standard Time',
      label: '(UTC+08:45) Eucla',
      offset: '+08:45',
    },
    {
      value: 'Transbaikal Standard Time',
      label: '(UTC+09:00) Chita',
      offset: '+09:00',
    },
    {
      value: 'Tokyo Standard Time',
      label: '(UTC+09:00) Osaka, Sapporo, Tokyo',
      offset: '+09:00',
    },
    {
      value: 'Korea Standard Time',
      label: '(UTC+09:00) Seoul',
      offset: '+09:00',
    },
    {
      value: 'Yakutsk Standard Time',
      label: '(UTC+09:00) Yakutsk',
      offset: '+09:00',
    },
    {
      value: 'Cen. Australia Standard Time',
      label: '(UTC+09:30) Adelaide',
      offset: '+09:30',
    },
    {
      value: 'AUS Central Standard Time',
      label: '(UTC+09:30) Darwin',
      offset: '+09:30',
    },
    {
      value: 'E. Australia Standard Time',
      label: '(UTC+10:00) Brisbane',
      offset: '+10:00',
    },
    {
      value: 'AUS Eastern Standard Time',
      label: '(UTC+10:00) Canberra, Melbourne, Sydney',
      offset: '+10:00',
    },
    {
      value: 'West Pacific Standard Time',
      label: '(UTC+10:00) Guam, Port Moresby',
      offset: '+10:00',
    },
    {
      value: 'Tasmania Standard Time',
      label: '(UTC+10:00) Hobart',
      offset: '+10:00',
    },
    {
      value: 'Vladivostok Standard Time',
      label: '(UTC+10:00) Vladivostok',
      offset: '+10:00',
    },
    {
      value: 'Lord Howe Standard Time',
      label: '(UTC+10:30) Lord Howe Island',
      offset: '+10:30',
    },
    {
      value: 'Bougainville Standard Time',
      label: '(UTC+11:00) Bougainville Island',
      offset: '+11:00',
    },
    {
      value: 'Russia Time Zone 10',
      label: '(UTC+11:00) Chokurdakh',
      offset: '+11:00',
    },
    {
      value: 'Magadan Standard Time',
      label: '(UTC+11:00) Magadan',
      offset: '+11:00',
    },
    {
      value: 'Norfolk Standard Time',
      label: '(UTC+11:00) Norfolk Island',
      offset: '+11:00',
    },
    {
      value: 'Sakhalin Standard Time',
      label: '(UTC+11:00) Sakhalin',
      offset: '+11:00',
    },
    {
      value: 'Central Pacific Standard Time',
      label: '(UTC+11:00) Solomon Is., New Caledonia',
      offset: '+11:00',
    },
    {
      value: 'Russia Time Zone 11',
      label: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
      offset: '+12:00',
    },
    {
      value: 'New Zealand Standard Time',
      label: '(UTC+12:00) Auckland, Wellington',
      offset: '+12:00',
    },
    {
      value: 'UTC+12',
      label: '(UTC+12:00) Coordinated Universal Time+12',
      offset: '+12:00',
    },
    {
      value: 'Fiji Standard Time',
      label: '(UTC+12:00) Fiji',
      offset: '+12:00',
    },
    {
      value: 'Kamchatka Standard Time',
      label: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
      offset: '+12:00',
    },
    {
      value: 'Chatham Islands Standard Time',
      label: '(UTC+12:45) Chatham Islands',
      offset: '+12:45',
    },
    {
      value: 'Tonga Standard Time',
      label: '(UTC+13:00) Nuku alofa',
      offset: '+13:00',
    },
    {
      value: 'Samoa Standard Time',
      label: '(UTC+13:00) Samoa',
      offset: '+13:00',
    },
    {
      value: 'Line Islands Standard Time',
      label: '(UTC+14:00) Kiritimati Island',
      offset: '+14:00',
    },
  ],
}
